module.exports = __webpack_public_path__ + "img/bathroom01.346b3e4f.jpg";